import { ForecastFolder } from "models/UserArpsModel";

export const transformFolderToNestedTreeData = (
  data: ForecastFolder[]
): ForecastFolder[] => {
  if (!data || data.length === 0) return [];

  const map = Object.create(null);
  const treeData = [];

  data.forEach((item) => {
    const itemKey = item.temporaryId || item.folderId;
    map[itemKey] = {
      ...item,
      key: itemKey,
      children: item.children ? [...item.children] : [],
      type: "folder",
      isFolder: true
    };
  });

  data.forEach((item) => {
    const itemKey = item.temporaryId || item.folderId;
    const node = map[itemKey];

    if (!item.parentId) {
      treeData.push(node);
    } else {
      const parent = map[item.parentId];
      if (parent) {
        if (!parent.children.some((c) => c.key === node.key)) {
          parent.children.push(node);
        }
      }
    }
  });

  const sortTree = (nodes) => {
    nodes.sort((a, b) => {
      const orderA = a.order ?? 0;
      const orderB = b.order ?? 0;

      if (orderA !== orderB) {
        return orderA - orderB;
      }

      return a.title.localeCompare(b.title, undefined, {
        numeric: true,
        sensitivity: "base"
      });
    });

    for (let i = 0; i < nodes.length; i++) {
      if (nodes[i].children?.length > 0) {
        sortTree(nodes[i].children);
      }
    }
  };

  if (treeData.length > 0) {
    sortTree(treeData);
  }

  return treeData;
};
